<template>
    <div class="Time">
        <div class="container">
            <div class="box-header">
                <div class="heading-copy">
                    <span class="heading-icon"><i class="el-icon-date"></i></span>
                    <div>
                        <h3>本周忙碌时间设置</h3>
                        <p>点击时段可切换状态；按住并向下拖动可连续设为忙碌</p>
                    </div>
                </div>
                <div class="header-modal-close" role="button" aria-label="关闭" @click.prevent="close">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="status-indicator">
                <div class="status-left">
                    <div class="status-card">
                        <span class="status-color status-free"></span>
                        <span class="status-label">空闲</span>
                        <strong>{{ freeCount }}</strong><small>个时段</small>
                    </div>
                    <div class="status-card">
                        <span class="status-color status-busy"></span>
                        <span class="status-label">忙碌</span>
                        <strong>{{ busyCount }}</strong><small>个时段</small>
                    </div>
                    <div class="weekend-toggles">
                        <el-checkbox v-model="busySaturday" @change="busySaturdayChange">周六设为忙碌</el-checkbox>
                        <el-checkbox v-model="busySunday" @change="busySundayChange">周日设为忙碌</el-checkbox>
                    </div>
                </div>
                <div class="status-right">
                    <el-button type="primary" @click="saveDate"><i class="el-icon-document-copy"></i>
                        保存日程</el-button>
                </div>
            </div>
            <div class="table-wrap">
                <el-table :data="tableData" height="480" border class="full-cell-table">
                    <el-table-column prop="time" label="时段" width="120" align="center">
                    </el-table-column>
                    <el-table-column v-for="day in days" :key="day.key" :label="day.name" align="center">
                        <template slot-scope="scope">
                            <div :class="['full-cell', scope.row[day.key] ? 'busy' : 'free']"
                            @pointerdown="startDragSelect(scope.$index, day.key)"
                            @pointerenter="continueDragSelect(scope.$index, day.key)"
                            @click="handleCellClick(scope.$index, day.key)"
                            @keyup.enter="toggleStatus(scope.$index, day.key)"
                            role="button" tabindex="0">
                                {{ scope.row[day.key] ? '忙碌' : '空闲' }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import { setTime, getTime } from "@/request/api";
export default {
    data() {
        return {
            busySaturday: false,
            busySunday: false,
            dragSelection: null,
            dragMoved: false,
            suppressNextCellClick: false,
            username: '',
            days: [
                { key: 'monday', name: '周一' },
                { key: 'tuesday', name: '周二' },
                { key: 'wednesday', name: '周三' },
                { key: 'thursday', name: '周四' },
                { key: 'friday', name: '周五' },
                { key: 'saturday', name: '周六' },
                { key: 'sunday', name: '周日' },
                { key: 'nextMonday', name: '下周一' },
            ],
            tableData: [
                { time: '09:00-09:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '09:30-10:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '10:00-10:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '10:30-11:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '11:00-11:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '11:30-12:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                //{ time: '12:00-12:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false,nextMonday: false },
                //{ time: '12:30-13:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false,nextMonday: false },
                { time: '13:00-13:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '13:30-14:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '14:00-14:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '14:30-15:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '15:00-15:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '15:30-16:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '16:00-16:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '16:30-17:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '17:00-17:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '17:30-18:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '18:00-18:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '18:30-19:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '19:00-19:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                { time: '19:30-20:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false, nextMonday: false },
                // { time: '20:00-20:30', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false,nextMonday: false },
                // { time: '20:30-21:00', monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false,nextMonday: false },
            ]
        }
    },
    computed: {
        busyCount() {
            let count = 0;
            this.tableData.forEach(row => {
                this.days.forEach(day => {
                    if (row[day.key]) count++;
                });
            });
            return count;
        },
        freeCount() {
            let count = 0;
            this.tableData.forEach(row => {
                this.days.forEach(day => {
                    if (!row[day.key]) count++;
                });
            });
            return count;
        }
    },
    mounted() {
        document.addEventListener('pointerup', this.finishDragSelect);
        document.addEventListener('pointercancel', this.finishDragSelect);
    },
    beforeDestroy() {
        document.removeEventListener('pointerup', this.finishDragSelect);
        document.removeEventListener('pointercancel', this.finishDragSelect);
    },
    methods: {
        async getTimeTable() {
            if (!this.username) return;
            try {
                const { data: res } = await getTime({ username: this.username });
                if (res && res.code === 200) {
                    this.formatTimeTable(res);
                } else {
                    this.$message.error('获取失败');
                }
            } catch (error) {
                this.$message.error('获取忙碌时间失败，请稍后重试');
            }
        },
        formatTimeTable(rawData) {
            // 1. 生成符合要求的时间段列表（09:00-20:00，每30分钟一段，排除12:00-13:00）
            const timeSlots = this.generateTimeSlots();

            // 2. 处理后端返回的星期数据，key统一转成小写（对应目标格式的字段）
            const data = rawData && rawData.data ? rawData.data : {};
            const parseDay = value => {
                if (Array.isArray(value)) return value.map(item => item === true || item === 1 || item === '1');
                if (value === undefined || value === null || value === '') return [];
                return String(value).split(',').map(item => item.trim() === '1');
            };
            const weekData = {
                monday: parseDay(data.Monday || data.monday),
                tuesday: parseDay(data.Tuesday || data.tuesday),
                wednesday: parseDay(data.Wednesday || data.wednesday),
                thursday: parseDay(data.Thursday || data.thursday),
                friday: parseDay(data.Friday || data.friday),
                saturday: parseDay(data.Saturday || data.saturday),
                sunday: parseDay(data.Sunday || data.sunday),
                nextMonday: parseDay(data.nextMonday || data.NextMonday)
            };

            // 3. 组装最终的时间表格数组
            this.tableData = timeSlots.map((time, index) => {
                return {
                    time: time,
                    monday: weekData.monday[index] || false,
                    tuesday: weekData.tuesday[index] || false,
                    wednesday: weekData.wednesday[index] || false,
                    thursday: weekData.thursday[index] || false,
                    friday: weekData.friday[index] || false,
                    saturday: weekData.saturday[index] || false,
                    sunday: weekData.sunday[index] || false,
                    nextMonday: weekData.nextMonday[index] || false
                };
            });
            this.busySaturday = this.checkAllSaturdayBusy('saturday');
            this.busySunday = this.checkAllSaturdayBusy('sunday');
        },
        checkAllSaturdayBusy(item) {
            // 使用循环方式检查是否所有周六都忙碌
            for (let i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i][item] !== true) {
                    return false; // 如果有任何一个周六不是true，则返回false
                }
            }
            return true; // 所有周六都是true时返回true
        },
        generateTimeSlots() {
            const slots = [];
            let startHour = 9;
            let startMinute = 0;

            // 结束时间：20:00
            while (startHour < 20) {
                // 计算结束时间
                let endHour = startHour;
                let endMinute = startMinute + 30;

                // 分钟进位处理
                if (endMinute === 60) {
                    endHour += 1;
                    endMinute = 0;
                }

                // 格式化时间字符串（补零）
                const startStr = `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}`;
                const endStr = `${endHour.toString().padStart(2, '0')}:${endMinute.toString().padStart(2, '0')}`;
                const timeSlot = `${startStr}-${endStr}`;

                // 排除12:00-13:00（包含12:00-12:30和12:30-13:00两个时段）
                if (!(timeSlot === '12:00-12:30' || timeSlot === '12:30-13:00')) {
                    slots.push(timeSlot);
                }

                // 更新下一个时段的开始时间
                startMinute = endMinute;
                if (startMinute === 0) {
                    startHour += 1;
                }
            }
            return slots;
        },
        busySaturdayChange() {
            if (this.busySaturday) {
                this.tableData.forEach(row => {
                    row.saturday = true;
                });
            } else {
                this.tableData.forEach(row => {
                    row.saturday = false;
                });
            }
        },
        busySundayChange() {
            if (this.busySunday) {
                this.tableData.forEach(row => {
                    row.sunday = true;
                });
            } else {
                this.tableData.forEach(row => {
                    row.sunday = false;
                });
            }
        },
        toggleStatus(rowIndex, dayKey) {
            this.tableData[rowIndex][dayKey] = !this.tableData[rowIndex][dayKey];
        },
        startDragSelect(rowIndex, dayKey) {
            this.dragSelection = {
                rowIndex,
                dayKey,
                targetStatus: !this.tableData[rowIndex][dayKey],
                originalStatus: this.tableData.map(row => this.days.map(day => !!row[day.key]))
            };
            this.dragMoved = false;
        },
        continueDragSelect(rowIndex, dayKey) {
            if (!this.dragSelection) return;
            const startDayIndex = this.days.findIndex(day => day.key === this.dragSelection.dayKey);
            const currentDayIndex = this.days.findIndex(day => day.key === dayKey);
            if (currentDayIndex < 0 || startDayIndex < 0) return;
            const isOrigin = rowIndex === this.dragSelection.rowIndex && currentDayIndex === startDayIndex;
            if (isOrigin && !this.dragMoved) return;
            if (isOrigin) {
                this.restoreDragSnapshot();
                return;
            }
            this.dragMoved = true;

            // 每次根据当前拖动范围重绘：回拖缩小范围时，已离开范围的单元格恢复手势前状态。
            this.restoreDragSnapshot();
            const firstRow = Math.min(this.dragSelection.rowIndex, rowIndex);
            const lastRow = Math.max(this.dragSelection.rowIndex, rowIndex);
            const firstDay = Math.min(startDayIndex, currentDayIndex);
            const lastDay = Math.max(startDayIndex, currentDayIndex);
            for (let row = firstRow; row <= lastRow; row++) {
                for (let day = firstDay; day <= lastDay; day++) {
                    this.tableData[row][this.days[day].key] = this.dragSelection.targetStatus;
                }
            }
        },
        restoreDragSnapshot() {
            if (!this.dragSelection) return;
            this.tableData.forEach((row, rowIndex) => {
                this.days.forEach((day, dayIndex) => {
                    row[day.key] = this.dragSelection.originalStatus[rowIndex][dayIndex];
                });
            });
        },
        finishDragSelect() {
            if (!this.dragSelection) return;
            if (this.dragMoved) {
                this.suppressNextCellClick = true;
                setTimeout(() => { this.suppressNextCellClick = false; }, 0);
            }
            this.dragSelection = null;
            this.dragMoved = false;
        },
        handleCellClick(rowIndex, dayKey) {
            if (this.suppressNextCellClick) {
                this.suppressNextCellClick = false;
                return;
            }
            this.toggleStatus(rowIndex, dayKey);
        },
        async saveDate() {
            var { data: res } = await setTime({ timeTable: this.tableData, username: this.username });
            if (res.code === 200) {
                console.log(res);
                this.$message.success('保存成功');
            } else {
                this.$message.error('保存失败');
            }
            console.log(this.tableData);
        },
        close() {
            this.$emit('TimeClose');
        },
    },
    created() {
        if (sessionStorage.getItem("LoginInfo")) {
            this.username = JSON.parse(sessionStorage.getItem("LoginInfo")).username;
        }

        this.getTimeTable();
    }
}
</script>

<style lang="scss" scoped>
.Time {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(10, 16, 28, .58);
    backdrop-filter: blur(3px);
}

.container {
    display: flex;
    flex-direction: column;
    width: min(1200px, calc(100vw - 48px));
    max-height: calc(100vh - 48px);
    padding: 0 22px 18px;
    overflow: hidden;
    border: 1px solid var(--border-hairline);
    border-radius: 16px;
    background: var(--bg-page);
    color: var(--text-primary);
    box-shadow: var(--shadow-pop);
    animation: time-dialog-in .2s ease-out;
}

@keyframes time-dialog-in {
    from {
        opacity: 0;
        transform: translateY(8px) scale(.99);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.box-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    min-height: 76px;
    border-bottom: 1px solid var(--divider);
}

.heading-copy {
    display: flex;
    align-items: center;
    gap: 12px;
}

.heading-icon {
    display: grid;
    place-items: center;
    width: 38px;
    height: 38px;
    border-radius: 11px;
    background: var(--brand-weak);
    color: var(--brand);
    font-size: 18px;
}

.heading-copy h3 {
    margin: 0;
    color: var(--text-primary);
    font-size: 18px;
    font-weight: 650;
}

.heading-copy p {
    margin: 5px 0 0;
    color: var(--text-secondary);
    font-size: 14px;
}

.header-modal-close {
    display: grid;
    place-items: center;
    width: 34px;
    height: 34px;
    border-radius: 8px;
    color: var(--text-secondary);
    font-size: 16px;
    cursor: pointer;
    transition: color .16s ease, background .16s ease;

    &:hover {
        color: var(--text-primary);
        background: var(--bg-hover);
    }
}

.status-indicator {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    flex-shrink: 0;
    padding: 16px 0 12px;
}

.status-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 9px;
}

.status-card {
    display: flex;
    align-items: center;
    gap: 7px;
    min-height: 36px;
    padding: 0 11px;
    border: 1px solid var(--border-hairline);
    border-radius: 8px;
    background: var(--bg-card);
}

.status-color {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.status-free {
    background: var(--success);
    box-shadow: 0 0 0 3px rgba(30, 170, 120, .12);
}

.status-busy {
    background: var(--danger);
    box-shadow: 0 0 0 3px rgba(231, 93, 107, .12);
}

.status-label {
    color: var(--text-regular);
    font-size: 14px;
}

.status-card strong {
    color: var(--text-primary);
    font-size: 16px;
}

.status-card small {
    color: var(--text-secondary);
    font-size: 13px;
}

.weekend-toggles {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-left: 5px;
}

::v-deep .weekend-toggles .el-checkbox {
    margin: 0;
    color: var(--text-regular);
}

::v-deep .weekend-toggles .el-checkbox__label {
    color: var(--text-regular);
    font-size: 14px;
}

::v-deep .weekend-toggles .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: var(--brand);
    background: var(--brand);
}

.status-right {
    flex-shrink: 0;
}

.status-right ::v-deep .el-button {
    min-height: 36px;
    padding: 0 16px;
    border-radius: 7px;
    background: var(--brand);
    border-color: var(--brand);
}

.status-right ::v-deep .el-button:hover {
    background: var(--brand-hover);
    border-color: var(--brand-hover);
}

.table-wrap {
    min-height: 0;
    overflow: auto;
    border: 1px solid var(--border-hairline);
    border-radius: 10px;
    background: var(--bg-card);
}

.full-cell-table {
    min-width: 850px;
}

.full-cell {
    position: absolute;
    inset: 4px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    border-radius: 6px;
    cursor: pointer;
    user-select: none;
    font-size: 14px;
    font-weight: 500;
    transition: background-color .16s ease, border-color .16s ease, color .16s ease, transform .16s ease;
}

.full-cell.free {
    background: var(--bg-page);
    color: var(--text-secondary);
}

.full-cell.free:hover {
    border-color: var(--brand-glow);
    background: var(--bg-active);
    color: var(--brand);
    transform: translateY(-1px);
}

.full-cell.busy {
    border-color: rgba(231, 93, 107, .2);
    background: rgba(231, 93, 107, .1);
    color: var(--danger);
}

.full-cell.busy:hover {
    border-color: var(--danger);
    background: rgba(231, 93, 107, .16);
    transform: translateY(-1px);
}

::v-deep .full-cell-table.el-table,
::v-deep .full-cell-table .el-table__expanded-cell {
    border-color: var(--border-hairline);
    background: var(--bg-card);
    color: var(--text-regular);
}

::v-deep .full-cell-table th.el-table__cell {
    padding: 10px 0;
    border-bottom-color: var(--divider);
    background: var(--bg-page);
    color: var(--text-secondary);
    font-weight: 600;
}

::v-deep .full-cell-table td.el-table__cell {
    position: relative;
    height: 42px;
    padding: 0;
    border-bottom-color: var(--divider);
    background: var(--bg-card);
}

::v-deep .full-cell-table .el-table__body tr:hover>td.el-table__cell {
    background: var(--bg-card);
}

::v-deep .full-cell-table::before,
::v-deep .full-cell-table .el-table__inner-wrapper::before {
    background: var(--divider);
}

::v-deep .full-cell-table .el-table__border-left-patch {
    background: var(--bg-page);
}

html.dark .full-cell.free {
    border-color: rgba(181, 198, 221, .12);
    background: #2a394c;
    color: #c4cfdf;
}
html.dark .full-cell.free:hover { border-color: var(--brand-glow); background: rgba(77, 156, 255, .18); color: #8fc2ff; }
html.dark .full-cell.busy { border-color: rgba(240, 143, 155, .28); background: rgba(240, 143, 155, .16); color: #ffabb4; }
html.dark .full-cell.busy:hover { border-color: #f08f9b; background: rgba(240, 143, 155, .24); }
html.dark .status-card { border-color: rgba(181, 198, 221, .2); background: #27364a; }
html.dark ::v-deep .full-cell-table th.el-table__cell { background: #202d3e; color: #b4c0d2; }

@media (max-width: 760px) {
    .Time {
        align-items: flex-end;
        padding: 0;
    }

    .container {
        width: 100%;
        max-height: 94vh;
        padding: 0 14px calc(14px + env(safe-area-inset-bottom));
        border-radius: 16px 16px 0 0;
    }

    .box-header {
        min-height: 66px;
    }

    .status-indicator {
        align-items: flex-start;
        flex-direction: column;
    }

    .status-left {
        width: 100%;
    }

    .status-right {
        align-self: flex-end;
    }

    .table-wrap {
        width: calc(100% + 1px);
    }

    ::v-deep .full-cell-table.el-table {
        height: min(480px, calc(94vh - 245px)) !important;
    }
}

@media (max-width: 480px) {
    .container {
        padding-right: 10px;
        padding-left: 10px;
    }

    .heading-copy p {
        max-width: 230px;
        line-height: 1.45;
    }

    .weekend-toggles {
        gap: 6px 10px;
        margin-left: 0;
    }

    .status-card {
        gap: 5px;
        padding: 0 8px;
    }

    .status-indicator {
        gap: 10px;
    }
}
</style>
